const LIST_IS_WINNER = [
    { id: 1, name: '当選' },
    { id: 0, name: '落選' }
];

const LIST_PRIZE_TYPE = [
    { id: 1, name: 'デジタル賞品' },
    { id: 2, name: '現物' }
];

const LIST_LOTTERY_STATE = [
    { id: 1, name: '事前選択' },
    { id: 2, name: '事前選択しない' }
];

const LIST_REGISTRATION_STATUS = [
    { id: 1, name: '入力済' },
    { id: 2, name: '未入力' },
    { id: 3, name: '不要' }
];

const LIST_HAS_SURVEY = [
    { id: 1, name: 'あり' },
    { id: 2, name: 'なし' }
];

const initSearchDataSerialCode = () => {
    return {
        search: {
            serial_code: '',
            prize_title: '',
            product_code: '',
            winner_uuid: ''
        },
        filters: {
            is_winner: [],
            prize_type: [],
            prize_id: [],
            lottery_state: [],
            registration_status: []
        },
        from: {
            lottery_at: ''
        },
        to: {
            lottery_at: ''
        }
    };
};

const initConfigDataSerialCode = () => {
    return {
        search: {
            serial_code: {
                error: false,
                isTrim: true,
                errorField: 'managerForm.settingPage.pageTypeB.serialCode',
                typesValidate: []
            },
            prize_title: {
                error: false,
                isTrim: true,
                errorField: 'managerForm.settingPage.pageTypeB.prizeName',
                typesValidate: []
            },
            product_code: {
                error: false,
                isTrim: true,
                errorField: 'managerForm.settingPage.pageTypeB.productCode',
                typesValidate: []
            },
            winner_uuid: {
                error: false,
                isTrim: true,
                errorField: 'managerForm.settingPage.pageTypeB.personalUrl',
                typesValidate: []
            }
        }
    };
};

export {
    initSearchDataSerialCode,
    initConfigDataSerialCode,
    LIST_IS_WINNER,
    LIST_PRIZE_TYPE,
    LIST_LOTTERY_STATE,
    LIST_REGISTRATION_STATUS,
    LIST_HAS_SURVEY
};
